module.exports = __webpack_public_path__ + "img/zuji.03e45024.png";